import React, { useState, useEffect } from "react";
import Topheader from "../components/HomePage/top_header";
import Header from "../components/HomePage/header";
import Pricing from "../components/HomePage/pricing";
import Footer from "../components/HomePage/footer";
import NewsletterPopup from "../Account/NewsletterPopup";
import { Helmet } from "react-helmet";

export default function PricingPage() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // Fetch subscription plans from the server
  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const response = await fetch("/api/category/main"); // Adjust the API endpoint accordingly
        if (!response.ok) {
          throw new Error("Failed to fetch subscription plans");
        }
        const data = await response.json();

        // Transform the fetched data to match the expected structure
        const mappedPlans = data.map((plan) => {
          // Parse cancelledMRP and price to numbers
          const cancelledMRP = parseFloat(
            plan.dynamicPricing?.basePrice || "0"
          );
          const price = parseFloat(plan.price || "0");

          // Calculate savings percentage
          const savingsPercent = cancelledMRP
            ? Math.round(((cancelledMRP - price) / cancelledMRP) * 100)
            : 0; // Default to 0 if cancelledMRP is 0
          const freeMonths = plan.dynamicPricing?.freeMonths || "No freeMonths";

          return {
            plan: plan.name, // Assuming 'name' is the title
            price, // Assuming 'price' field exists
            planID: plan.planID, // Assuming 'planID' exists
            duration: plan.months, // Assuming 'months' field exists
            features: plan.description.split("\n"), // Assuming 'description' contains features
            savings: savingsPercent > 0 ? `${savingsPercent}` : "No Savings",
            additionalDetails:
              plan.additionalDetails || "No additional details",
            promotion: plan.promotion || "No promotion",
            freeMonths,
            cancelledMRP:
              cancelledMRP > 0 ? `$${cancelledMRP.toFixed(2)}` : "$0",
          };
        });

        setPlans(mappedPlans);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch subscription plans");
        setLoading(false);
      }
    };

    fetchPricingData();
  }, []);
  return (
    <>
      <Helmet>
        <title>
          PrepNexa Pricing – Affordable AI-Powered PTE Practice Plans
        </title>
        <meta
          name="description"
          content="Choose from flexible and affordable PrepNexa plans for AI-powered PTE mock tests, instant feedback, and unlimited practice. Start your PTE prep today!"
        />
        <meta
          name="keywords"
          content="PrepNexa pricing, PTE mock test plans, PTE practice pricing, affordable PTE prep, AI PTE plans"
        />
        <meta name="author" content="PrepNexa Team" />
        <link rel="canonical" href="https://prepnexa.com/pricing" />

        {/* Open Graph Tags */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="PrepNexa Pricing – Affordable AI-Powered PTE Practice Plans"
        />
        <meta
          property="og:description"
          content="Explore flexible pricing for AI-driven PTE mock tests, feedback, and preparation tools. Prep smarter with PrepNexa."
        />
        <meta property="og:url" content="https://prepnexa.com/pricing" />
        <meta
          property="og:image"
          content="https://prepnexa.com/images/pricing-banner.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="PrepNexa Pricing – Affordable PTE Prep Plans"
        />
        <meta
          name="twitter:description"
          content="AI-powered PTE preparation at a price that works for you. Check out our flexible pricing plans."
        />
        <meta
          name="twitter:image"
          content="https://prepnexa.com/images/pricing-banner.png"
        />
      </Helmet>

      <Topheader plans={plans[1]} />
      <Header />
      <Pricing plans={plans} />
      <NewsletterPopup />
      {/* <Faq /> */}
      <Footer />
    </>
  );
}
